var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgInductionPrimary = function SvgInductionPrimary(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 227,
    viewBox: "0 0 328 227",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: "103.4%",
    height: "154.2%",
    x: "-1.7%",
    y: "-18.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 0.5,
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__c",
    width: "106%",
    height: "105.4%",
    x: "-3%",
    y: "-2.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 0.5,
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "prefix__b",
    d: "M21.108 222c-5.602.004-10.975-2.252-14.934-6.27-3.96-4.017-6.181-9.467-6.174-15.147C0 199.156 1.14 198 2.547 198h316.906c1.407 0 2.547 1.156 2.547 2.583.004 5.679-2.219 11.126-6.178 15.143-3.959 4.017-9.33 6.274-14.93 6.274H21.108z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__d",
    d: "M77 12H245V198H77z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 267,
    height: 186,
    x: 27,
    y: 35,
    fill: "#67748A",
    fillRule: "nonzero",
    rx: 10.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DAF8",
    fillRule: "nonzero",
    d: "M277.78 209l-234.425-1.353c-.371 0-.726-.151-.982-.42-.256-.268-.39-.63-.373-1l.881-156.874c0-.747.606-1.353 1.353-1.353l234.413 1.353c.747 0 1.353.606 1.353 1.353l-.866 156.941c0 .747-.606 1.353-1.353 1.353z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__a)",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#67748A",
    xlinkHref: "#prefix__b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5DAF8",
    fillRule: "nonzero",
    d: "M199.68 204h-77.36c-4.595 0-8.32-2.239-8.32-5h94c-.007 2.76-3.728 4.996-8.32 5z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#prefix__c)",
    xlinkHref: "#prefix__d"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#prefix__d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF5C",
    fillRule: "nonzero",
    d: "M240.184 18.65L81.843 19c-1.55.004-3.04-.608-4.136-1.699-1.096-1.09-1.71-2.571-1.707-4.114V6.136c0-3.198 2.602-5.792 5.816-5.8L240.157 0c1.548-.004 3.035.606 4.13 1.694C245.385 2.782 246 4.259 246 5.8v7.05c.004 1.537-.608 3.013-1.699 4.1-1.09 1.089-2.572 1.7-4.117 1.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 74,
    x: 104,
    y: 31,
    fill: "#00C48C",
    fillRule: "nonzero",
    rx: 7.36
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M145 80.782V51.227c0-3.598 2.574-6.127 5.042-4.924l30.424 14.771c3.379 1.637 3.379 8.224 0 9.861l-30.424 14.771c-2.468 1.177-5.042-1.325-5.042-4.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCC19C",
    fillRule: "nonzero",
    d: "M223.931 127H97.068c-.816 0-1.598-.315-2.174-.876-.576-.56-.897-1.32-.894-2.11-.01-.796.308-1.563.884-2.13.577-.565 1.364-.884 2.184-.884h126.863c.814 0 1.594.313 2.17.871.575.558.899 1.314.899 2.103.014.798-.303 1.567-.88 2.137-.577.569-1.365.89-2.189.889zM146.925 143h-49.85c-.818 0-1.602-.317-2.18-.881-.576-.565-.899-1.33-.895-2.126 0-1.653 1.377-2.993 3.075-2.993h49.85c1.698 0 3.075 1.34 3.075 2.993 0 1.656-1.375 3-3.075 3.007zM146.938 169H97.076c-1.699 0-3.076-1.34-3.076-2.993-.004-.797.319-1.561.896-2.126.577-.564 1.362-.881 2.18-.881h49.862c1.695.014 3.062 1.356 3.062 3.007 0 1.648-1.369 2.986-3.062 2.993zM210.907 169h-49.882c-1.676-.036-3.018-1.363-3.025-2.993 0-1.66 1.385-3.007 3.093-3.007h49.814c1.708 0 3.093 1.346 3.093 3.007-.007 1.655-1.39 2.993-3.093 2.993zM191.94 143h-27.88c-1.69 0-3.06-1.346-3.06-3.007.007-1.655 1.375-2.993 3.06-2.993h27.88c1.685 0 3.053 1.338 3.06 2.993 0 .798-.322 1.563-.896 2.126-.574.564-1.352.881-2.163.881z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInductionPrimary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inductionPrimary.0794fcce.svg";
export { ForwardRef as ReactComponent };